















































































































import { Component, Vue, Watch } from 'vue-property-decorator';

import { TextField, Picture, Typography } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import MarketingCenterPostCard from '@/components/molecules/MarketingCenterPostCard/MarketingCenterPostCard.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';
import {
  IMarketingCenterGetAsset,
  IMarketingCenterGetPost
} from '@/models/marketingCenter/post';
import MarketingCenterService from '@/api/MarketingCenterService';
import { EMarketingCenterFormats } from '@/models/marketingCenter/format';
import eventBus from '@/utils/eventBus';

@Component({
  components: {
    FilledButton,
    TextField,
    Picture,
    Typography,
    TableFilters,
    MarketingCenterPostCard,
    Page
  }
})
export default class MarketingCenterPostList extends Vue {
  posts: IMarketingCenterGetPost[] = [];
  nextPage: string = '';
  search: string = '';
  debouncedValue: string = '';
  loading: boolean = false;
  debounce?: ReturnType<typeof setTimeout>;
  marketingCenterAPI = new MarketingCenterService();
  listEmpty: boolean = true;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get title() {
    return 'Social Media Assets';
  }

  async created() {
    await this.getPosts();
    this.$nextTick(function() {
      this.createObserver();
    });
    this.listEmpty = !this.posts.length;
  }

  async getPosts(reset: boolean = false) {
    this.$showLoaderWithLocker();
    this.loading = true;

    if (reset) {
      this.posts = [];
    }

    const response = await this.marketingCenterAPI.listPosts(this.nextPage);

    if (response.status === 200) {
      this.posts = [...this.posts, ...response.data.items];
      if (response.data.links.next) {
        this.nextPage = response.data.links.next;
      } else {
        this.nextPage = '';
      }
    }

    this.$hideLoader();
    this.loading = false;
  }

  @Watch('search')
  debounceSearch() {
    if (this.debounce) {
      clearTimeout(this.debounce);
    }

    this.debounce = setTimeout(() => {
      this.debouncedValue = this.search;
      this.nextPage = `/post?skip=0&limit=10&searchableFields=name&search=${
        this.debouncedValue
      }`;
      this.getPosts(true);

      this.$analytics({
        eventCategory: 'Social Media Assets | Search',
        eventAction: 'click',
        eventLabel: `Search term: ${this.debouncedValue}`
      });
    }, 800);
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  createObserver() {
    const target = this.$refs.target as HTMLElement;

    const observer = new IntersectionObserver(async entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && this.nextPage.length) {
          this.getPosts();
        }
      });
    });

    if (target) {
      observer.observe(target);
    }
  }

  gotoTemplate({ isEmptyState = false } = {}) {
    if (isEmptyState) {
      this.$analytics({
        eventCategory: 'Social Media Assets | Empty State',
        eventAction: 'click',
        eventLabel: 'Clicked on the "Explore The Marketing Center" button'
      });
    } else {
      this.$analytics({
        eventCategory: 'Social Media Assets | Create new post button',
        eventAction: 'click',
        eventLabel: 'Clicked on the "Create new post" button'
      });
    }

    this.$router.push(
      '/marketing-center/social-media-templates/template-select'
    );
  }

  gotoPost(post: IMarketingCenterGetPost) {
    this.$router.push({
      path: `/marketing-center/social-media-templates/post/${
        post.id
      }/post-editor`
    });
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  getPostThumb(post: IMarketingCenterGetPost) {
    const format = post.assets.find(
      (asset: IMarketingCenterGetAsset) =>
        asset.type === EMarketingCenterFormats.instagramPost
    );

    if (format) {
      return format.publicPath.url;
    }

    if (post.assets.length) {
      return post.assets[0].publicPath.url;
    }
  }

  mounted() {
    eventBus.$on('marketingCenterPostDeletion', () => this.getPosts(true));
  }
}
